import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import {ToastrService} from 'ngx-toastr';
import {RenewPasswordRequest} from '../_model/request/RenewPasswordRequest';
import {AuthenticationService} from '../_services/authentication.service';
import {User} from '../_model/user';
import {Router} from '@angular/router';
import {PortaluserService} from "../_services/portaluser.service";
import {ProfileResponse} from "../_model/response/profile.response";
import {ApiResponse} from "../_model/ApiResponse";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatIconModule,
    MatTableModule,
    DatePipe
  ]
})
export class ProfileComponent implements OnInit {

  updatePasswordForm =  this.formBuilder.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword2: ['', [Validators.required, Validators.minLength(8)]]},
      {validator: this.checkPasswords});
  renewPasswordRequest: RenewPasswordRequest;
    updateProfileForm = this.formBuilder.group( {
        newName: ['', [Validators.required],Validators.minLength(1)],
        newSurname: ['', [Validators.required, Validators.minLength(1)]],
        newEmail: ['', [Validators.required, Validators.minLength(1)]],
        newTel:['', Validators.required, Validators.minLength(1)],
        }
    )
  profileResponse: ProfileResponse = {} as ProfileResponse;
  submitButtonName = 'Kaydet';
  submitted = false;
  currentUser: User;
  showAlert = true;
  fileUploadRoot = environment.fileUploadPath;
  displayedColumns: string[] = ['type', 'days'];
  absenceDataSource: any[] = [];
    filePath = null;


  constructor(private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private authService: AuthenticationService,
              private portaluserService: PortaluserService,
              private router: Router) { }

  ngOnInit() {
      this.currentUser = this.authService.currentUserValue;
      this.portaluserService.getProfile(this.currentUser.employeeId).subscribe(result => {
          this.profileResponse = result.responseData.item;
          if (this.profileResponse?.profilePhoto) {
              this.filePath = this.profileResponse.profilePhoto.filePath;
          }
          
          // İzin verilerini tablo için dönüştür
          if (this.profileResponse?.deservedAbsences) {
            this.absenceDataSource = Object.entries(this.profileResponse.deservedAbsences).map(([type, days]) => ({
              type,
              days
            }));
          }
      });
  }
  updatePassword() {
      this.renewPasswordRequest = this.updatePasswordForm.getRawValue();
      this.authService.renewPassword(this.renewPasswordRequest).subscribe(renewResult => {
        this.toastr.success('Şifre güncellendi', 'Başarılı');
      }, error2 =>  {
        this.toastr.error(error2.msg, 'Hata');
      }, () => {
        this.authService.logout();
        this.router.navigate(['login']);
      });
      this.updatePasswordForm.reset();
  }

  checkPasswords(group: FormGroup) {
      const newPassword = group.get('newPassword').value;
      const newPassword2 = group.get('newPassword2').value;
      return newPassword === newPassword2 ? null : { notSame: true };
  }

  closeAlert() {
    this.showAlert = false;
  }
}
